import { TemplateElement, defineElement, html, when } from '@webtides/element-js';
import '../../../slider/slider.js';
import styles from '../../../../../packages/magnolia-content/magnolia-content.css';

export default class EBankingSliderGroup extends TemplateElement {
    slides = [];
    addedSlides = [];

    constructor() {
        super({
            shadowRender: true,
            styles: [styles],
        });
    }

    connected() {
        this.swiperEl = this.$refs.swiper;

        const swiperParams = {
            pagination: {
                el: this.$refs.pagination,
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                prevEl: this.$refs.previousButton,
                nextEl: this.$refs.nextButton,
            },
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 24,
            on: {
                init: () => {
                    this.setAttribute('swiper-connected', 'true');
                },
            },
        };

        Object.assign(this.swiperEl, swiperParams);
        this.swiperEl.initialize();
    }

    template() {
        const slides = Array.from(Array(this.childElementCount || 0).keys());

        return html`
            <swiper-container
                class="block"
                ref="swiper"
                init="false"
                navigation="${this.navigation}"
                pagination="${this.pagination}"
                scrollbar="${this.scrollbar}"
            >
                ${slides.map((content, index) => {
                    return html`<swiper-slide><slot name="slide-${index}">${index}</slot></swiper-slide>`;
                })}
            </swiper-container>
            <div class="flex justify-center gap-40 mt-16">
                <div ref="previousButton" class="navigation swiper-button-prev">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20.0251 7.20361L11.707 15.5217C11.4427 15.786 11.4427 16.2144 11.707 16.4787L20.0251 24.7968"
                            stroke="#144B3C"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <div
                    ref="pagination"
                    class="pagination *:[.swiper-pagination-bullet-active]:bg-green-medium"
                    style="width: auto !important; display: flex; align-items: center;"
                ></div>
                <div ref="nextButton" class="navigation swiper-button-next">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.9751 3.20361L16.2932 11.5217C16.5575 11.786 16.5575 12.2144 16.2932 12.4787L7.9751 20.7968"
                            stroke="#144B3C"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </div>
        `;
    }

    styles() {
        return [
            `
            .swiper-pagination-bullet-active {
                background-color: var(--mdx-sys-color-primary-default, #144B3C);
            }
        `,
        ];
    }
}

defineElement('mb-e-banking-slider-group', EBankingSliderGroup);
